import styled from 'styled-components'
import { colorTheme } from '../../../../../../style/theme/colorTheme'
import { theme } from '../../../../../../style/theme'

export const InvoiceOptionsStatus = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.94em;
	padding: 0.63em 0 1.25em;
	font-size: 1rem;
`
InvoiceOptionsStatus.displayName = 'InvoiceOptionsStatus'

export const InvoiceOptionsStatusBar = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.44em;
	width: 100%;
	padding: 0.88em 0;

	> svg {
		flex-shrink: 0;
		width: 1.75em;
		height: 1.75em;
		fill: ${colorTheme.invoices.modal.invoiceData.label.icon};
	}

	&.green {
		background-color: ${colorTheme.invoices.modal.invoiceData.label.backgroundGreen};
	}

	&.orange {
		background-color: ${colorTheme.invoices.modal.invoiceData.label.backgroundOrange};
	}

	&.canceled {
		background-color: ${colorTheme.invoices.modal.invoiceData.label.backgroundCanceled};
	}
`
InvoiceOptionsStatusBar.displayName = 'InvoiceOptionsStatusBar'

export const InvoiceOptionsStatusText = styled.div`
	color: ${colorTheme.invoices.modal.invoiceData.label.text};
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.25em;
	font-weight: 600;
`
InvoiceOptionsStatusText.displayName = 'InvoiceOptionsStatusText'

export const InvoiceOptionsStatusDate = styled.div`
	display: flex;
	gap: 0.35em;
	font-size: 1.25em;
	color: ${colorTheme.invoices.modal.optionsModal.statusDate};
`
InvoiceOptionsStatusDate.displayName = 'InvoiceOptionsStatusDate'

export const InvoiceOptionsStatusDateLabel = styled.span`
	font-family: ${theme.fontRobotoBold};
	font-weight: 700;
`
InvoiceOptionsStatusDateLabel.displayName = 'InvoiceOptionsStatusDateLabel'
